import { Component, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';

import { Customer } from 'graphql/models/generated';
import { CustomerSearchComponent } from 'shared/forms/customer/search/search.component';

@Component({
  selector: 'app-customer-without-condition-search',
  templateUrl: './search-customers-without-condition.component.html',
  styleUrls: ['./search-customers-without-condition.component.scss']
})
export class SearchCustomersWithoutConditionComponent {
  @ViewChild(CustomerSearchComponent) searchComponent!: CustomerSearchComponent;

  get selectedItem(): Customer {
    return this.searchComponent.selectedItem;
  }

  constructor() {}

  onSubmit(): Observable<Customer> {
    return this.searchComponent.onSubmit();
  }

  onItemSelected(): void {
    /* Needed to satisfy checks in the multimodal component */
  }
}
